export default "__VITE_ASSET__cb5f2f7b__"